import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'lib-flexible/flexible.js';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/style/fonts.scss';
import './assets/style/index.scss';

import api from '@/server/apiSite/index'; // 接口地址
import http from '@/server/request.js'; // 请求 axios

import VConsole from 'vconsole';
if (process.env.NODE_ENV === 'development') {
  const v = new VConsole();
  console.log(v);
}

// 引入 mockjs
if (process.env.VUE_APP_USE_MOCK === 'true') {
  console.log('✅ Mock enabled');
  require('./mock');
}

Vue.prototype.api = api; // 挂载到Vue实例上面
Vue.prototype.http = http; // 挂载到Vue实例上面

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  created() {
    // 初始化系统参数
  },
  render: (h) => h(App),
}).$mount('#app');
